import { Col, Form } from "antd";
import {
  GET_ALL_TNA_DEPARTMENT_DATA,
  PROBLEM_REMEDY,
  PROBLEM_REMEDY_PROBLEM,
  PROBLEM_REMEDY_PROBLEM_TYPE,
  PROBLEM_REMEDY_REASON,
} from "apiServices/API_ENDPOINTS";
import AddAndSelect from "common/AddAndSelect";

const RemedyMapFilter = ({ initialTableData }) => {
  return (
    <>
      <Col span={4}>
        {/* Department */}
        <Form.Item name="tna_department_id" label="Department">
          <AddAndSelect
            placeholder="Select Department"
            optionUrl={GET_ALL_TNA_DEPARTMENT_DATA}
            searchKeyword="title"
            optionResponseFormat={(response) => {
              const data = response.data?.data?.data;
              return data.map((item) => ({
                label: item.title,
                value: item.id,
              }));
            }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        {/* Problem Type */}
        <Form.Item name="problem_type_id" label="Problem Type">
          <AddAndSelect
            placeholder="Select Problem Type"
            optionUrl={PROBLEM_REMEDY_PROBLEM_TYPE}
            searchKeyword="name"
            optionResponseFormat={(response) => {
              const data = response.data?.data?.data;
              return data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }}
          />
        </Form.Item>
      </Col>

      <Col span={4}>
        {/* Problem */}
        <Form.Item name="problem_id" label="Problem">
          <AddAndSelect
            placeholder="Select Problem"
            optionUrl={PROBLEM_REMEDY_PROBLEM}
            searchKeyword="name"
            optionResponseFormat={(response) => {
              const data = response.data?.data?.data;
              return data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        {/* Reason */}
        <Form.Item name="reason_id" label="Reason">
          <AddAndSelect
            placeholder="Select Reason"
            optionUrl={PROBLEM_REMEDY_REASON}
            searchKeyword="name"
            optionResponseFormat={(response) => {
              const data = response.data?.data?.data;
              return data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        {/* Remedy */}
        <Form.Item name="remedy_id" label="Remedy">
          <AddAndSelect
            placeholder="Select Remedy"
            optionUrl={PROBLEM_REMEDY}
            searchKeyword="name"
            optionResponseFormat={(response) => {
              const data = response.data?.data?.data;
              return data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
            }}
          />
        </Form.Item>
      </Col>
    </>
  );
};

export default RemedyMapFilter;
